import { CompressImage } from "../types";

export const getCompressedImages = (images: CompressImage[]) => images.filter((image) => image.state === "compressed");
